/**
 * Cliente Supabase — Portal Cliente Menuee
 *
 * Responsabilidad: instancia única de @supabase/supabase-js para PostgREST y RPC.
 *
 * Consume: REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_ANON_KEY (mismo proyecto que Menuee Admin).
 *
 * Qué nunca debe hacer:
 * - Contener lógica de negocio, mappers ni llamadas a tablas específicas.
 * - Usar service_role key en el frontend (solo anon key).
 * - Duplicar instancias createClient en otros módulos.
 *
 * Compatibilidad Menuee: PostgreSQL 15+, Auth, RLS, RPC E0–E6 vía supabase.rpc().
 */

import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (process.env.NODE_ENV === "development") {
  if (!supabaseUrl || !supabaseAnonKey) {
    console.warn(
      "[Menuee Portal] Faltan REACT_APP_SUPABASE_URL o REACT_APP_SUPABASE_ANON_KEY. " +
        "Las consultas a Supabase fallarán hasta configurar .env"
    );
  }
}

/**
 * Cliente Supabase compartido por services/ y rpcClient.
 * Misma instancia Supabase que gastro-admin (multi-tenant vía RLS).
 */
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
